module.exports = __webpack_public_path__ + "static/img/logo_toyota.14aeb91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_toyota.png
// module id = QbkR
// module chunks = 13